import { TextField, MenuItem, Box, Typography } from "@mui/material";
import moment from "moment";

const months = [
  { month: "None", alias: "" },
  { month: "January", alias: "01" },
  { month: "February", alias: "02" },
  { month: "March", alias: "03" },
  { month: "April", alias: "04" },
  { month: "May", alias: "05" },
  { month: "June", alias: "06" },
  { month: "July", alias: "07" },
  { month: "August", alias: "08" },
  { month: "September", alias: "09" },
  { month: "October", alias: "10" },
  { month: "November", alias: "11" },
  { month: "December", alias: "12" },
];

export default function DashboardFilter({ 
  years, 
  handleYearFilterChange, 
  selectedYear, 
  selectedMonth,
  handleMonthFilterChange 
}) {
    // Get current month and year in the correct format
    const currentMonth = moment().format("MM"); // This gives "01", "02", etc.
    const currentYear = moment().format("YYYY");

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        if (name === "month") {
            // Check if handleMonthFilterChange exists, otherwise use selectedMonth if it's a function
            if (handleMonthFilterChange) {
                handleMonthFilterChange(value);
            } else if (typeof selectedMonth === 'function') {
                selectedMonth(value);
            }
        } else if (name === "year") {
            handleYearFilterChange(value);
        }
    };

    return (
      <Box sx={{ display: { xs: "block", sm: "flex", md: "flex" }, alignItems: "center" }}>
        <Typography variant="h5" sx={{ marginBottom:{ xs: "10px", sm: 0 } }}>Filter:</Typography>
        <TextField
          label="Month"
          size="small"
          select
          value={selectedMonth || currentMonth}
          name="month"
          onChange={handleFilterChange}
          sx={{width:"150px",marginBottom: { xs: "20px", sm: 0 },marginLeft: { xs: "0px", sm: "10px" }}}
        >
            {months.map((month, index) => {
                return <MenuItem key={index} value={month.alias}>{month.month}</MenuItem>
            })}
        </TextField>

        <TextField
          label="Year"
          size="small"
          value={selectedYear || currentYear}
          select
          name="year"
          onChange={handleFilterChange}
          sx={{ width:"150px", marginBottom: { xs: "20px", sm: 0 }, marginRight: { xs: "0px", sm: "50px" } }}
        >
          {years.map((year, index) => {
            return (
              <MenuItem key={index} value={year}>{year}</MenuItem>
            );
          })}
        </TextField>
      </Box>
    );
}